export const SectionHead = ({ no, title, sub, light }) => (
  <div className="flex items-end gap-4">
    <span className={`text-5xl font-black leading-none md:text-6xl ${light ? "text-white/40" : "text-[#EF8E35]/40"}`}>{no}</span>
    <div>
      <h2 className={`text-2xl font-black md:text-3xl ${light ? "text-white" : "text-[var(--ink)]"}`}>{title}</h2>
      {sub && <p className={`mt-1 text-base md:text-lg ${light ? "text-white/80" : "text-[var(--text)]"}`}>{sub}</p>}
    </div>
  </div>
);
